import React, { useState, useEffect } from 'react';
import IconWithText from 'components/Widgets/IconWithText';

import { useContext } from 'components/Members/Onboarding/Context';

import ProgressBar from 'components/Widgets/ProgressBar';

import buildProgramImg from 'images/new_ui/build-program.png';

export default function PrepareBuildProgram() {
  const { dispatch, state, actions } = useContext();

  const [progress, setProgress] = useState(0);

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 1;
        return next <= 100 ? next : 100;
      });
    }, 100);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      onGoNextClick();
    }
  }, [progress]);

  return (
    <>
      <div className="onboarding-content my-5">
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
          <ProgressBar now={progress} />
        </div>
      </div>
      <div className="content onboarding-content">
        <div className="row">
          <div className="col-lg-3 text-center">
            <img src={buildProgramImg} alt="Build Program" style={{ maxWidth: '70%', margin: '40px 20px' }} />
          </div>
          <div className="col-lg-9">
            <div className="pt-4 p-sm-4 pe-lg-0">
              <h1>Welcome to your personalized Talent Insurance Program!</h1>
              <p className="mt-3">
                Tailored to support your unique goals, this program builds on insights from your
                Talent Assessment, with a focus on both career and leadership growth.
              </p>

              <IconWithText
                iconClassName="big-icon summarize-icon bg-secondary"
                wrapperClassName="mb-3"
              >
                <h6>We make it simple for you to find career success</h6>
              </IconWithText>

              <p>
                We&apos;re here to make success attainable by providing resources that strengthen your
                productivity, life balance, and leadership skills.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
